﻿import { LitElement, html, css } from 'lit'
import Panel, { Modal } from 'bui/presenters/panel'
import '../utils/pdf-viewer.js'; 
import { fFormatDate, fJSONParse, fMessageCache } from '../utils/helper.js';
import router from 'bui/app/router'

customElements.define('mod-auftragsliste', class extends LitElement {

    static get title() { return 'Auftragsliste' }
    static get icon() { return 'assignment' }
    static get id() { return 'auftragsliste' }


    static properties = {
        data: { type: Object },
        error: { type: String }
    };


    static get styles() {
        return css`
        :host {
            display: grid;
            position:relative;
            height: 100%;
            overflow: hidden;
            --sticky-header-background: #f5f5f5
        }

  

        main {
            margin: 0.75rem auto var(--view-gutter, 2em);
            height: calc(100% - 0.75rem - var(--view-gutter, 2em));
            max-width: calc(100% - (var(--view-gutter, 2em) * 2));
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }

        .order-view {
                height: 100%;
                min-height: 0;
                overflow: hidden;
        }

        .order-header {
                flex: 0 0 auto;
                position: relative;
                z-index: 2;
                padding-right: 7em;
                padding-bottom: 0.75rem;
                background: var(--sticky-header-background);
        }

        .order-header b-avatar {
            --size: 8em;
            position: absolute;
            top: 0;
            right: 0;
        }

        b-tabs {
            flex: 1 1 auto;
            min-height: 0;
            overflow-y: auto;
            overscroll-behavior: contain;
            scrollbar-gutter: stable;
        }

        b-tabs::part(tab-bar) {
            position: sticky;
            top: 0;
            z-index: 3;
            background: var(--sticky-header-background);
        }

        b-paper {     
            margin-top: 30px;         
            font-size: 14px;
        }
 

         b-grid {           
            font-size: 14px;
        }
        
        b-tabs > * {
            min-width: 0;
        }

        b-tabs-router::part(tab-bar) {
            background-color: var(--theme-bgd);
        }

        
       b-avatar {
            --size: 8em;
        }
        
        .gray-small{
            color: gray;
            font-size: 14px;    
        }

        .pdf-thumbnail {
            width: 421px;
            height: 318px;
            background-color: white;
            background-size: 100% auto;
            background-position: center;
            background-repeat: no-repeat;
            position: relative;
            overflow: hidden;
            cursor: pointer; 
            position: relative;
        }

        .pdf-spinner {
            display: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 3rem;
            height: 3rem;
            animation: spin;
        }

        .pdf-thumbnail.loading .pdf-spinner {
            display: block;
        }

        a {
            color: black;
            text-decoration: none;
        }

        a:hover {
            text-decoration: underline;
        }

        .pdf-thumbnail-label {
            position: absolute;
            bottom: 5px;
            left: 5px;
            color: white;
            background-color: rgba(0, 0, 0, 0.5);
            padding: 2px 5px;
            font-size: 15px;
        }

        .pdf-thumbnail-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0);
            transition: background-color 0.3s ease;
        }

        .pdf-thumbnail:hover .pdf-thumbnail-overlay {
            background-color: rgba(0, 0, 0, 0.4);
        }

        @media (max-width: 599px) {
            b-avatar {
            --size: 5em;
        }

        .order-header {
                padding-right: 0;
            }

        .order-header b-avatar {
                --size: 5em;
                position: static;
            }

         main {
            margin: 0.75rem auto;
            height: calc(100% - 1.5rem);
            max-width: calc(100% - 1.5rem);
        }

    `}


    constructor() {
        super();
        this.data = null;
        this.error = null;
        this._isLoading = false;
        this._intervalId = null;
        this.lastReloadTime = 'Lade...'
    }


    connectedCallback() {
        super.connectedCallback();
        const cachedTime = localStorage.getItem('lastReloadTime');
        if (cachedTime) {
            this.lastReloadTime = `${cachedTime}`;
            this.requestUpdate();
        }
        this.fetchData();
        this._intervalId = setInterval(() => this.fetchData(), 900000); // 15 Minuten
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._intervalId) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }
    }

    async fetchData() {

        if (this._isLoading) {
            return;
        }

        const activeTab = localStorage.getItem('tab-bar:mod-auftragsliste:active');
        
        const cleanString = activeTab ? activeTab.replace(/^"|"$/g, '') : null;
        
        const btn = this.renderRoot.querySelector('#refreshButton' + cleanString);

        if (btn) {
            btn.spin = true;
        }

        try {
            this._isLoading = true;
            const baseUrl = window.location.hostname === 'localhost'
                ? 'http://localhost:61131'
                : '.';        
        
            const tokenString = localStorage.getItem('laportal-token');
             
            const response = await fetch(baseUrl + '/apiAuftragsliste.ashx', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-LA-Token': tokenString               
                }
            });

            if (!response.ok) throw new Error(`HTTP error ${response.status}`);

            this.data = await response.json();

            const now = new Date();
            const currentTime = now.toLocaleTimeString('de-DE', {
                hour: '2-digit',
                minute: '2-digit'
            });

            localStorage.setItem('lastReloadTime', currentTime);

            this.lastReloadTime = `${currentTime}`;

            this._sharedPreselectedTour();
             

            if (tokenString && this.data && this.data.failed) {
                const tokenList = fJSONParse(tokenString);
                if (tokenList) {
                    const updatedTokens = tokenList.filter(token =>
                        !this.data.failed.includes(token)
                    );
                    localStorage.setItem('laportal-token', JSON.stringify(updatedTokens));
                }
            }


        } catch (err) {
            this.error = err.message;
        } finally {
            this._isLoading = false;

            if (btn) {
                btn.spin = false;
            }
        }
       
    }

    _sharedPreselectedTour() {
        const tourIdToSelect = localStorage.getItem('laportal-tour-select');     
        if (!tourIdToSelect || !this.data || !this.data.result || this.data.result.length === 0) {
            return;
        }

        let selectedTourFound = false;

        for (const item of this.data.result) {
            if (item.tour && item.tour.length > 0) {
                const selectedTour = item.tour.find(tour =>
                    String(tour.Schl_Number) === tourIdToSelect
                );

                if (selectedTour) {
                    this.openPdfPanel(selectedTour);
                    selectedTourFound = true;
                    break;
                }
            }
        }

        if (!selectedTourFound) {
            this.error = `Ausgewählte Tour-ID "${tourIdToSelect}" konnte nicht in den Daten gefunden werden.`;
        } 
        localStorage.removeItem("laportal-tour-select");
    }

    getStatusLabel(status, mod, Loading_Time) {
        var sText = '';
        var sColor = '';

        if (Loading_Time) {
            var now = new Date();
            var lt = new Date(Loading_Time);
            var thisDay = now.getFullYear() === lt.getFullYear() && now.getMonth() === lt.getMonth() && now.getDate() === lt.getDate();

            if (thisDay) {

                var minDiff = (now - lt) / (1000 * 60);

                var statusGeliefert = [
                    'Ankunft_Werk',
                    'PumpAbbau',
                    'Abfahrt_Bst'
                ];

                if (minDiff >= 90 && !statusGeliefert.includes(status)) {
                    sText = 'Unvollständig';
                    sColor = 'orange';

                    switch (mod) {
                        case 'text':
                            return sText;
                        case 'style':
                            return sColor;
                    }
                }
            }

        }

        switch (status) {
            case 'Ankunft_Werk':
            case 'PumpAbbau':
            case 'Abfahrt_Bst':
                sText = 'Geliefert';
                sColor = 'green';
                break;
            case 'Abgeschlossen':
                sText = 'Abgeschlossen';
                sColor = 'green';
                break;
            case 'Beginn_Laden':
            case 'Abfahrt_Werk':
            case 'Ankunft_Bst':
            case 'PumpAufbau':
            case 'Beginn_Entladen':
            case 'Pumpen':
            case 'In_Bearbeitung':
                sText = 'Bearbeitung';
                sColor = 'orange';
                break;
            case 'Storniert':
                sText = 'Storniert';
                sColor = 'red';
                break;
            default:
                //Eingeplant, Steuerung, Eingeplant, Zu_bestätigen
                sText = 'Geplant';
                sColor = 'gray';
                break;
        }

        switch (mod) {
            case 'text':
                return sText;
            case 'style':
                return sColor;
        }
    }

    getLinkLabel(url) {
        var sLabel = '';   
        if (url && typeof url === 'string') {
    
            try {             
                var token = url.split('/')[4];                
                var decoded = atob(token);
                sLabel = decoded.split('-')[2];
            } catch (e) {
                sLabel = "Link";
            }
        };
        
        return sLabel;
    }

 
    togglePdf(messages) {
        var sResult = true;
        if (messages) {
            var hasPDF = messages.some(msg => /\.pdf$/i.test(msg.text));
            if (hasPDF) {
                sResult = false;
            }
        }
        return sResult;
    }

    hideEmtyLabel(txt) {
        var sResult = true;
        if (txt && txt != '' && txt != '00:00') {
            sResult = false;
        }
        return sResult;
    }

    getTrueTime(time1, time2, mode) {
        let zeit = null;
        if (time2 && time2 != '' && time2 !='00:00') {
            zeit = time2
        }
        if (!zeit) {
            if (time1 && time1 != '' && time1 != '00:00') {
                zeit = time1;
            }
        }
        switch (mode) {
            case 'text':
                return zeit;
                break;
            case 'style':
                if (!zeit) {
                    return true;
                }
                break;
        }
    }

    
   

    async downloadAllPdfs() {
        const btn = this.renderRoot.querySelector(`#allPdfsButton`);
        const baseUrl = window.location.hostname === 'localhost'
            ? 'http://localhost:61131'
            : '.';

        const postData = JSON.stringify({
            "id": this.data.result[0].ID,
            "value": "attachmentById"
        });

        if (btn) {
            btn.spin = true;
        }
        
            const response = await fetch(`${baseUrl}/apiMessages.ashx?name=AttachmentDownload&Format=Base64`, {
                method: "POST",
                body: postData,
                headers: {
                    "Content-Type": "application/json",
                    "x-la-token": `["${this.data.result[0].token}"]`
                }
            });

        if (response.ok) {
            const data = await response.json();
            console.log('data', data[0].text);
             

            const base64Data = data[0].text.replace("data:application/x-zip-compressed;base64,", "");
            

            const zipBlob = this._base64toBlob(base64Data, 'application/x-zip-compressed');
            
            if (zipBlob.size === 0) {
                alert("Der Server hat eine leere Datei gesendet. Bitte prüfen Sie die Server-Logs.");
                return;
            }
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(zipBlob);
            downloadLink.download = `Auftrag_${this.data.result[0].auftragID}.zip`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadLink.href)
        } else {
            console.error("HTTP Error", response.status, await response.text());
            alert("Das Herunterladen der ZIP-Datei ist fehlgeschlagen.");
        }
        if (btn) {
            btn.spin = false;
        }
    }
    

    async openPdfPanel(tour) {
        // Spinner aktivieren
        const btn = this.renderRoot.querySelector(`#pdfButton${tour.Schl_Number}`);       
        const imageDiv = this.renderRoot.querySelector(`#pdfImage${tour.Schl_Number}`);


        if (btn) {
            btn.spin = true; 
        }

        if (imageDiv) {
            imageDiv.classList.add('loading');
        }

        var self = this;
        // PDF-Datei extrahieren (erste gefundene)
        const pdfMsg = tour.messages.find(msg => /\.pdf$/i.test(msg.text));
        if (!pdfMsg) return;

        var id = pdfMsg.ID;


        //Find Cache
        //var myMessageCache = fMessageCache('Find', self.data.result, id);
        let myMessageCache = await fMessageCache('Find', self.data.result, id);
                
        //Download if required
        if (myMessageCache == '') {
            await fMessageCache('Download', self.data.result, id);
            myMessageCache = await fMessageCache('Find', self.data.result, id);
        }

        //Validate Cache
        var usePDFViewer = false;
        if (myMessageCache && myMessageCache != '' && myMessageCache.text) {
            if (myMessageCache.text.indexOf("data:application/pdf;base64,") >= 0) {
                usePDFViewer = true;
            }
        }

        const base64Data = myMessageCache.text.replace("data:application/pdf;base64,", "");
        if (usePDFViewer) {    
            const panel = new Panel(() => {
                const dynamicFilename = `LS_${tour.Schl_Number}.pdf`;
                const download = () => this._downloadBase64Pdf(base64Data, dynamicFilename);
                const share = () => this._shareBase64Pdf(base64Data, dynamicFilename);
                return html`
                    <b-flex col stretch gap=0>
                      <b-panel-toolbar shadow>                   
                        <span slot="left">                          
                            <b-btn @click=${download} stacked icon="download" text>Herunterladen</b-btn>                           
                            <b-btn @click=${share} stacked icon="share" text>Teilen</b-btn>                    
                        </span>                        
                    </b-panel-toolbar>
                      <main style="flex:1; padding:1rem; overflow:auto;">
                        <pdf-viewer .base64=${base64Data}></pdf-viewer>
                      </main>
                    </b-flex>
                  `;
            });
            panel.open();
        }


        //Spinner stoppen
        if (btn) {
            btn.spin = false;
        }

        if (imageDiv) {
            imageDiv.classList.remove('loading');
        }
 


    }

    _downloadBase64Pdf(base64, filename = 'document.pdf') {
        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${base64}`;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    async _shareBase64Pdf(base64, filename = 'document.pdf') {
        if (!base64) {
            console.error('Kein Base64-PDF-String gefunden.');
            alert('Kein PDF zum Teilen verfügbar.');
            return;
        }
        const pdfBlob = this._base64toBlob(base64, 'application/pdf');

        if (navigator.share) {
            try {
                const pdfFile = new File([pdfBlob], filename, { type: "application/pdf" });

                await navigator.share({
                    title: 'Lieferschein',
                    text: 'Anbei die Lieferschein PDF',
                    files: [pdfFile]
                });
                console.log('PDF erfolgreich geteilt');
            } catch (error) {
                console.error('Fehler beim Teilen des PDFs:', error);
                alert('Das Teilen ist fehlgeschlagen oder wird von deinem Browser nicht unterstützt.');
            }
        } else {
            console.warn('Web Share API nicht verfügbar.');
            alert('Dein Browser unterstützt die Teilen-Funktion nicht.');
        }
    }


    _base64toBlob(base64, contentType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

    _onTabChanged(e) {      
        if (!this._isLoading) {
            this.fetchData();
        }  
    }

    _test(e) {
        router.goTo('erneuern', { extra: 'props' })
       // router.push('/#/home')     // oder router.push('/step2') je nach Version
    }

    _removeOrder(item) {
        const confirmed = window.confirm(
            `Auftrag ${item.auftragID} wirklich aus der Liste entfernen?\n\n` +
            'Der Link bleibt gültig und kann später erneut geöffnet werden.'
        );

        if (!confirmed) return;

        const tokenList = fJSONParse(localStorage.getItem('laportal-token')) || [];
        const updatedTokens = tokenList.filter(token => token !== item.token);

        if (updatedTokens.length > 0) {
            localStorage.setItem('laportal-token', JSON.stringify(updatedTokens));
        } else {
            localStorage.removeItem('laportal-token');
        }

        const remainingOrders = this.data.result.filter(order => order.token !== item.token);
        this.data = { ...this.data, result: remainingOrders };

        const activeOrder = localStorage
            .getItem('tab-bar:mod-auftragsliste:active')
            ?.replace(/^"|"$/g, '');

        // Falls gerade der gelöschte Auftrag aktiv war: nächsten Auftrag öffnen.
        if (String(activeOrder) === String(item.auftragID)) {
            if (remainingOrders.length > 0) {
                localStorage.setItem(
                    'tab-bar:mod-auftragsliste:active',
                    JSON.stringify(remainingOrders[0].auftragID)
                );
            } else {
                localStorage.removeItem('tab-bar:mod-auftragsliste:active');
                localStorage.setItem(
                    'tab-bar:app-view:active',
                    JSON.stringify('erneuern')
                );
                router.goTo('erneuern');
            }
        }

        this.requestUpdate();
    }

    render() {

        if (this.error) {
            return html`<p>Fehler: ${this.error}</p>`;
        }
        if (!this.data) {
            return html`<p style="margin-left: 10px;">Lade Daten...</p>`;
        }
          
        return html`

            <b-tabs-router path="auftragsliste/" key="mod-auftragsliste" @active-changed=${this._onTabChanged}>  
                ${this.data.result.map(item => html`
                  
                    <div class="order-view" title="${item.auftragID}" view-id="${item.auftragID}">
                        <main>

                            <header class="order-header">
                            <b-flex left style="margin-bottom: 1rem;">
                                <div>
                                    <b-text bold lg>Auftrag ${item.auftragID}</b-text>
                                </div>
                                <div>  
                                    <!--<b-label filled="green">ZTV-Ing.</b-label>
                                    <b-label filled="blue">Vorabunterschrift aktiv</b-label> -->
                                    <b-label filled="${this.getStatusLabel(item.status, 'style')}">${this.getStatusLabel(item.status, 'text')}</b-label>
                                </div>                        
                            </b-flex>

                            <b-flex wrap stretch>
                                <div style="flex: 1;">
                                    <b-grid style="display: grid; grid-template-columns: max-content auto; gap: 0.3em;" >
                                        <b-text bold>Kunde: </b-text>
                                        <b-text>${item.rechnungAdresse.firma}</b-text>
                                        <b-text bold>Baustelle:</b-text>
                                        <b-text>${item.lieferAdresse.firma}</b-text>
                                        <b-text bold>IST/SOLL-Menge:</b-text>
                                        <b-text>${item.tour ? item.tour.reduce((sum, tour) => sum + tour.Volume, 0) : 0} / ${item.volume_ist > item.volume_soll ? item.volume_ist : item.volume_soll} cbm</b-text>
                                    </b-grid>
                                </div>                         
                                    <b-avatar .url=${"data:image/jpeg;base64," + item.logo} shadow></b-avatar>
                            </b-flex>
                            </header>

                        <b-tabs>
                            <section title="Touren" style="padding-top: 0;">

                            ${item.tour && item.tour.length > 0 ? html`                        

                                ${item.tour.map(tour => html`

                                    <b-paper overshadow>
                                       <b-details>
                                                <div toggles>
                                                    <b-flex  wrap style="padding-bottom:10px;">
                                                        <b-flex >
                                                            <b-text lg bold>Tour ${tour.Load_Number}</b-text>
                                                            <b-text lg> <b-label filled="${this.getStatusLabel(tour.Status, 'style')}">${this.getStatusLabel(tour.Status, 'text')}</b-label></b-text>
                                                        </b-flex>
                                                        <b-flex>
                                                            <b-btn id="pdfButton${tour.Schl_Number}" icon="file_present" color="red" ?hidden=${this.togglePdf(tour.messages)} outline   @click=${() => this.openPdfPanel(tour)} >PDF Dokument</b-btn>                                                         
                                                        </b-flex>                                                 
                                                    </b-flex>      

                                                    <b-flex  wrap stretch  style="padding-bottom:10px;">                                               
                                                            <b-grid style="display: grid; grid-template-columns: max-content auto;" >  
                                                                <b-text lg bold>LS#:</b-text>
                                                                <b-text lg>${tour.Schl_Number}</b-text>
                                                                <b-text lg bold>Menge:</b-text>
                                                                <b-text lg>${tour.Volume} cbm</b-text>
                                                            </b-grid>      
                                                    </b-flex>
                                                </div>                                                             
                                                 <b-flex top   wrap style="padding-left:17px;">
                                                    <b-grid cols="2">
                                                        <b-text ?hidden=${this.getTrueTime(tour.Loading_Time, tour.Loading_Ist_Time, 'style')}><span class="fixed-label">Beladen:</span></b-text>
                                                        <b-text ?hidden=${this.getTrueTime(tour.Loading_Time, tour.Loading_Ist_Time, 'style')}>${this.getTrueTime(tour.Loading_Time, tour.Loading_Ist_Time,'text')}</b-text>
                                                        <b-text ?hidden=${!tour.Arrival_Ist_Time}>Ankunft Baustelle:</b-text>
                                                        <b-text ?hidden=${!tour.Arrival_Ist_Time}>${tour.Arrival_Ist_Time}</b-text>
                                                        <b-text ?hidden=${this.getTrueTime(tour.Start_Time, tour.Start_Ist_Time, 'style')}>Beginn Entladung:</b-text>
                                                        <b-text ?hidden=${this.getTrueTime(tour.Start_Time, tour.Start_Ist_Time, 'style')}>${this.getTrueTime(tour.Start_Time, tour.Start_Ist_Time, 'text')}</b-text>
                                                        <b-text ?hidden=${this.getTrueTime(tour.Finish_Time, tour.Finish_Ist_Time, 'style')}>Ende Entladung:</b-text>
                                                        <b-text ?hidden=${this.getTrueTime(tour.Finish_Time, tour.Finish_Ist_Time, 'style')}>${this.getTrueTime(tour.Finish_Time, tour.Finish_Ist_Time, 'text')}</b-text>
                                                    </b-grid>
                                                    <b-grid cols="2">
                                                        <b-text>Werk:</b-text>
                                                        <b-text>${tour.Plant}</b-text>
                                                        <b-text>Fahrzeug:</b-text>
                                                        <b-text>${tour.Vehicle_Plate}</b-text>                                              
                                                    </b-grid> 
                                                    <b-grid cols="2">
                                                        <b-text ?hidden=${this.hideEmtyLabel(tour.bemerkung)}>Bemerkung:</b-text>
                                                        <b-text ?hidden=${this.hideEmtyLabel(tour.bemerkung)}>${tour.bemerkung}</b-text>
                                                     </b-grid>
                                                </b-flex>
                                          </b-details>         
                                    </b-paper>
                
                                    `)}
                                        <div>
                                            <b-text class="gray-small">Der Link ist bis zum</b-text>
                                            <b-text style="margin-top:20px;" class="gray-small">${fFormatDate(item.expiration)}</b-text>
                                            <b-text class="gray-small">gültig.</b-text>
                                            <b-text class="gray-small">Datenstand: ${this.lastReloadTime}</b-text>
                                        </div>
                                        <div>
                                            <b-btn id="refreshButton${item.auftragID}" class="gray-small" icon="refresh" @click=${() => this.fetchData()} outline>Aktualisieren</b-btn>
                                            <b-btn class="gray-small" icon="delete_outline" color="red" outline @click=${() => this._removeOrder(item)}>Auftrag entfernen</b-btn>
                                        </div>
                             ` : ''}

                            </section>

                            <section title="Dokumente">
                                ${item.tour && item.tour.length > 0 ? html`
                                        ${(() => {
                                            const hatPdfs = item.tour.some(tour =>
                                                tour.messages.some(msg => msg.text.endsWith('.pdf'))
                                            );

                                            if (!hatPdfs) {
                                                return html`<b-text>Keine Dokumente vorhanden</b-text>`;
                                            }

                                        return html`
                                            <b-flex style="margin-bottom: 1.5rem;">
                                                <b-btn
                                                    id="allPdfsButton"
                                                    icon="file_present"
                                                    color="red"
                                                    outline   @click=${() => this.downloadAllPdfs(item.tour)} >
                                                    Zip Herunterladen
                                                </b-btn>
                                            </b-flex>

                                            <b-flex wrap stretch>
                                            ${item.tour.map(tour => {
                                                const pdfMessages = tour.messages.filter(msg => msg.text.endsWith('.pdf'));
                                                const signedPdf = pdfMessages.find(msg => msg.text.includes('_signed.pdf'));
                                                const orgPdf = pdfMessages.find(msg => msg.text.includes('_org.pdf'));
                                                const firstPdf = pdfMessages.length > 0 ? pdfMessages[0] : null;
                                                const pdfToDisplay = signedPdf || orgPdf || firstPdf;

                                                if (pdfToDisplay) {
                                                    return html`
                                                    <div id="pdfImage${tour.Schl_Number}" @click="${() => this.openPdfPanel(tour)}" class="pdf-thumbnail" style="background-image: url('data:image/jpeg;base64,${pdfToDisplay.details}');">
                                                            <span class="pdf-thumbnail-overlay">
                                                            <span class="pdf-thumbnail-label">LS#: ${tour.Schl_Number}</span>
                                                        </span>
                                                        <b-spinner spin class="pdf-spinner"></b-spinner>
                                                    </div>
                                                `;
                                                }
                                                return '';
                                            })}
                                            </b-flex>
                                            `;
                                        })()}
                                    ` : html`
                                    `}
                            </section>
                            
                            <section title="Details" style="padding-top: 0;">

                                ${item.tour ?.length > 0 ? html`                        

                                <b-paper style="padding: 1em; margin-top: 0; background: var(--sticky-header-background, #f5f5f5); box-shadow: none;">
                                    <div style="display: grid; grid-template-columns: max-content minmax(0, 1fr); column-gap: 1.5rem; row-gap: 0.5em; align-items: baseline;">
                                        <b-text bold>Liefertag:</b-text>
                                        <b-text>${fFormatDate(item.am)}</b-text>
                                        <b-text bold>Baustellennummer:</b-text>
                                        <b-text>${item.lieferAdresse.matchcode || '-'}</b-text>
                                        <b-text bold>Strasse:</b-text>
                                        <b-text>${item.lieferAdresse ?.strasse || '-'}</b-text>
                                        <b-text bold>Bauteil:</b-text>
                                        <b-text>${item.bauteil || '-'}</b-text>
                                        <b-text bold>Werk:</b-text>
                                        <b-text>${item.tour[0] ?.Plant || '-'}</b-text>
                                        <b-text bold>Artikelnummer:</b-text>
                                        <b-text>${(item.sorte || '').split('***')[0] ?.trim() || '-'}</b-text>
                                        <b-text bold>Artikelbezeichnung:</b-text>
                                        <b-text>${(item.sorte || '').split('***')[1] ?.trim() || '-'}</b-text>
                                        <b-text bold ?hidden=${this.hideEmtyLabel(item.related)}>Verknüpfte Aufträge:</b-text>
                                        <div style="display: flex; flex-wrap: wrap; gap: 4px;" ?hidden=${this.hideEmtyLabel(item.related)}>
                                            ${Array.isArray(item.related)
                                            ? item.related.map(url => html`
                                                <a href="${url}">
                                                    ${this.getLinkLabel(url)}
                                                </a>
                                                `)
                                            : html`<a href="${item.related}">${this.getLinkLabel(item.related)}</a>`
                                            }
                                        </div>
                                            <div style="grid-column: 1 / -1; justify-self: start; display: flex; gap: 0.5em; margin-top: 0.8em;">
                                                <b-btn id="refreshButton${item.auftragID}" class="gray-small" icon="refresh" @click=${() => this.fetchData()} outline>Aktualisieren</b-btn>
                                                <b-btn class="gray-small" icon="delete_outline" color="red" outline @click=${() => this._removeOrder(item)}>Auftrag entfernen</b-btn>
                                            </div>
                                            <div style="grid-column: 1 / -1; justify-self: start; margin-top: 0.5em; display: flex; flex-direction: column; gap: 0.2em; text-align: left;">
                                                <b-text class="gray-small">Der Link ist bis zum ${fFormatDate(item.expiration)} gültig.</b-text>
                                                <b-text class="gray-small">Datenstand: ${this.lastReloadTime}</b-text>
                                            </div>
                                    </div>
                                </b-paper>
                                ` : ''}
                            </section>

                           </b-tabs>

                        </main>
                    </div>
                                                   
                `)}
            </b-tabs-router>   
 
    `}

 

})
 
export default customElements.get('mod-auftragsliste')
